import VMasker from 'vanilla-masker';
const countryCodeRegEx = /^\D*1?/;
const phoneNumberFormatPattern = '999-999-9999';
export const removePhoneNumberCountryCode = (phoneNumber) => `${phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : ''}`.replace(countryCodeRegEx, '');
export default (phoneNumber) => VMasker.toPattern(removePhoneNumberCountryCode(phoneNumber), phoneNumberFormatPattern);
//# sourceMappingURL=phone-number-to-formatted-string.js.map